import React from 'react';

import colors from '../sl-colors';

interface Props extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

export default function SolidAlertCircle({ color = colors.error['DEFAULT'], ...props }: Props) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.3334 10C18.3334 14.6023 14.6024 18.3333 10.0001 18.3333C5.39771 18.3333 1.66675 14.6023 1.66675 10C1.66675 5.39763 5.39771 1.66667 10.0001 1.66667C14.6024 1.66667 18.3334 5.39763 18.3334 10ZM10.0001 6.04167C10.3452 6.04167 10.6251 6.3215 10.6251 6.66667V10.8333C10.6251 11.1785 10.3452 11.4583 10.0001 11.4583C9.65491 11.4583 9.37508 11.1785 9.37508 10.8333V6.66667C9.37508 6.3215 9.65491 6.04167 10.0001 6.04167ZM10.0001 14.1667C10.4603 14.1667 10.8334 13.7936 10.8334 13.3333C10.8334 12.8731 10.4603 12.5 10.0001 12.5C9.53983 12.5 9.16675 12.8731 9.16675 13.3333C9.16675 13.7936 9.53983 14.1667 10.0001 14.1667Z"
        fill={color}
      />
    </svg>
  );
}
